import { ActionSettings, TableDataRequest } from '@fl/cmsch-fe-library';
import React, { Fragment, FC, memo, useCallback, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { Opt } from 'ts-opt';
import { BasicRole } from 'api/gen/BasicRole';
import { useOurTranslation } from 'app/translations';
import { Ant } from 'common/ant';
import { ConnectedTable } from 'utils/tables';
import { subordinateRoleTableColumns } from './columns';
import { adminAction } from '../../model';
import { simpleAdminSelector } from '../../model/selector';
interface Props {
  /** Parent role id whose subordinate roles are shown. */
  parentRoleId: number;
  /** Whether subordinate-role changes are allowed. */
  canUpdateRole: boolean;
}
const SubordinateRoleAssignedTableBase: FC<Props> = ({
  parentRoleId,
  canUpdateRole
}) => {
  const {
    t
  } = useOurTranslation('admin');
  const dispatch = useDispatch();
  const onTableFetch = useCallback((tableDataRequest: Opt<TableDataRequest<BasicRole>>) => {
    dispatch(adminAction.getSubordinateAssignedRoles(tableDataRequest, parentRoleId));
  }, [dispatch, parentRoleId]);
  const handleRemoveClick = useCallback((subordinateRoleId: number) => {
    dispatch(adminAction.changeSubordinateRole(parentRoleId, subordinateRoleId, 'remove'));
  }, [dispatch, parentRoleId]);
  const actionSettings: ActionSettings<BasicRole> = useMemo(() => ({
    extraActions: [{
      id: 'removeSubordinateRole',
      role: 'delete',
      confirmClick: false,
      callback: handleRemoveClick,
      hidden: !canUpdateRole
    }]
  }), [canUpdateRole, handleRemoveClick]);
  return <Fragment>
            <div className="mx-2">
                <Ant.Typography.Title level={5} data-sentry-element="unknown" data-sentry-source-file="assigned-table.tsx">
                    {t('subordinateAssignedRoles')}
                </Ant.Typography.Title>
            </div>
            <ConnectedTable tableId="roleSubordinateAssignedRoles" columns={subordinateRoleTableColumns} onFetchTableData={onTableFetch} rowDataPageSelector={simpleAdminSelector.subordinateAssignedRolePage} actionSettings={actionSettings} withoutVerticalScrollbar lazyLoadingLimit={20} showFulltextFilter enableTableSettings enableTableUserSettings data-sentry-element="ConnectedTable" data-sentry-source-file="assigned-table.tsx" />
        </Fragment>;
};

/**
 * Assigned subordinate-role table.
 *
 * @example
 * <SubordinateRoleAssignedTable
 *   parentRoleId={123}
 *   canUpdateRole
 * />
 */
export const SubordinateRoleAssignedTable = memo(SubordinateRoleAssignedTableBase);